// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useState, useEffect } from 'react';
import {  getPCConsoleMarkets } from '@/pages/intelligence/pages/MarketProfile/_config/_testData';
import { getMarketProfileFilterMarket} from '@/pages/intelligence/services/marketProfile';
interface TableHooks {
  entity_type: string | undefined;
}
interface ResultInterface {
  region_country?: any[];
  [key: string]: any;
}
const RankTrendTableHooks = function ({
  entity_type,
  filterLoading,
  regionOptions,
}: TableHooks) {
  // 用于搜索的所有国家筛选内容
  const [allSearchMarketsList, setAllSearchMarketsList] = useState([]);
  // 用于搜索的国家筛选内容
  const [selectSearchMarketList, setSelectSearchMarketList] = useState([]);
  //
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  //
  const [pageIndex, setPageIndex] = useState(1);
  const getContryList = async () => {
    try {
      const result: ResultInterface = await getMarketProfileFilterMarket({
        entity_type,
        "regions": entity_type === 'pc' || entity_type === 'console' ? getPCConsoleMarkets() : [],
      }) || {};
      const regionCountryList = result?.region_country || [];
      const countryData = [] as any;
      regionCountryList?.forEach((item:any) => {
        if(item.continent!==''){
          item?.country_set?.forEach((t:any) => {
            countryData.push({
              name: t?.name === 'Congo'
                ? 'Republic of the Congo'
                : t?.name,
              enName: t?.abbre
            });
          });
        }

      });
      // 筛选后搜索国家的列表
      setSelectSearchMarketList(countryData);
      // 全部搜索国家的列表
      setAllSearchMarketsList(countryData);
    } catch (err) {
      console.log('err', err);
    }
  };
  useEffect(() => {
    getContryList();
  }, []);
  useEffect(() => {
    // 手动添加Overall-global
    // abbre: "global" country_cn: "",name: "Global"
    // abbre: "global_wo_china" country_cn: "",name: "Global Except China Mainland"
    const regions = regionOptions ? [...regionOptions] : [] as any;
    setRegionsCountries(regions);
  }, [regionOptions]);
  return {
    allSearchMarketsList,
    selectSearchMarketList,
    regionsCountries,
    pageIndex,
    setPageIndex,

  };
};
export default RankTrendTableHooks;
